import { render, staticRenderFns } from "./PageAuthorView.vue?vue&type=template&id=167b3d3f&scoped=true"
import script from "./PageAuthorView.vue?vue&type=script&lang=js"
export * from "./PageAuthorView.vue?vue&type=script&lang=js"
import style0 from "./PageAuthorView.vue?vue&type=style&index=0&id=167b3d3f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "167b3d3f",
  null
  
)

export default component.exports